import { CareerListing } from '../../settings-module/components/career-page/career-page.model';

export class CareerSubDomain {
  id: number;
  subdomain: string;
  career_page_id: number;

  constructor(props) {
    this.id = props.id;
    this.subdomain = props.subdomain;
    this.career_page_id = props.career_page_id;
  }
}
